import Img from 'src/components/shared/Img'
import React, { Fragment } from 'react'
import { resolveContentfulImageSrc } from 'src/common/resolveContentfulImageSrc'
import {
  trustMarkerEntryAlt,
  trustMarkerEntryId,
  trustMarkerEntryImage,
} from 'src/common/trustMarkerEntryFields'
import { Section } from '../SectionV2'

const IMAGE_DIMENSIONS = {
  BBB: {
    mobile: { h: 70, w: 124 },
    desktop: { h: 80, w: 142 },
    className: 'mx-auto h-[70px] w-[124px] lg:h-[80px] lg:w-[142px]',
  },
  'USA Today': {
    mobile: { h: 80, w: 80 },
    desktop: { h: 80, w: 80 },
    className: 'mx-auto h-[80px] w-[80px] lg:h-[80px] lg:w-[80px]',
  },
  'Forbes advisor': {
    mobile: { h: 54, w: 177 },
    desktop: { h: 54, w: 210 },
    className: 'mx-auto h-[54px] w-[177px] lg:h-[54px] lg:w-[210px]',
  },
  Money: {
    mobile: { h: 55, w: 133 },
    desktop: { h: 63, w: 152 },
    className: 'mx-auto h-[55px] w-[133px] lg:h-[63px] lg:w-[152px]',
  },
}

const TrustMarkersCombinationLogos = ({
  title,
  trustMarkersCombination = {},
}) => {
  const markers =
    trustMarkersCombination?.trustMarker?.filter((t) =>
      resolveContentfulImageSrc(trustMarkerEntryImage(t))
    ) ?? []

  return (
    <Section variant="primary">
      {title && (
        <Section.Typography as="h2" variant="label-overline">
          {title}
        </Section.Typography>
      )}
      <div className="lg:h-27 mt-6 flex flex-col items-center justify-evenly gap-x-11 gap-y-6 lg:flex-row">
        {markers.map((trustMarker, i) => {
          const id = trustMarkerEntryId(trustMarker)
          const src = resolveContentfulImageSrc(
            trustMarkerEntryImage(trustMarker)
          )
          const dims = IMAGE_DIMENSIONS[id]

          return (
            <Fragment key={trustMarker.key ?? id ?? i}>
              {i > 0 && (
                <div className="hidden h-full border-l border-primary lg:block" />
              )}
              {i > 0 && (
                <div className="block w-[258px] border-t border-primary lg:hidden" />
              )}
              <Img
                src={src}
                alt={trustMarkerEntryAlt(trustMarker)}
                loading="eager"
                height={dims ? dims.desktop.h : 84}
                width={dims ? dims.desktop.w : 0}
                className={dims?.className}
                layout="intrinsic"
              />
            </Fragment>
          )
        })}
      </div>
    </Section>
  )
}

export default TrustMarkersCombinationLogos
